"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPublicAffairs = function IconPublicAffairs(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m27.65 6.473.183.166 3.01 2.89L39 17.581V23h-3v13.97h3v6H10v-2h27v-2H13v-2h6v-14h-6v-2h15V21h1v-.03h2V21h6v-2.582l-7.552-7.457-3-2.878a3 3 0 0 0-4.05-.088l-.14.132-1.848 1.847-1.414-1.414 1.848-1.848a5 5 0 0 1 6.62-.394zM31 23h3v13.97h-3zM21 36.97h3V23h-3zM26 23h3v13.97h-3zm-.12-7.79a1.91 1.91 0 1 1-3.82 0 1.91 1.91 0 0 1 3.82 0",
    clipRule: "evenodd"
  })));
};

export { IconPublicAffairs, IconPublicAffairs as default };
